module.exports = __webpack_public_path__ + "img/ic_12_clock_white.e02a5c39.svg";